/* src/app/components/lead-details/authorization/auth-allocation/auth-allocation.component.css */
/*# sourceMappingURL=auth-allocation.component-YNVFP4EH.css.map */
